import { buildSchema } from 'graphql'

export const schema = buildSchema(`
  type Company {
    companyName: String
    companyNumber: String
  }
`)
